addEventListener('DOMContentLoaded', function() {

  // ── Restore state on page load ──────────────────────────────────────────────
  var wishlist_pro = [];
  try {
    wishlist_pro = JSON.parse(localStorage.getItem('wishlist')) || [];
  } catch(e) {}

  // Mark already-wishlisted buttons
  $(".wishlist-custom-action").each(function() {
    var handle = $(this).attr("data-handle");
    if ($.inArray(handle, wishlist_pro) >= 0) {
      $(this).addClass('active-wishlist').removeClass('wishlist-custom-action');
    }
  });

  // Update counter
  $('.wishlist-counter').text(wishlist_pro.length || '0');

  // ── Add to wishlist ─────────────────────────────────────────────────────────
  jQuery(document).on('click', '.wishlist-custom-action', function(e) {
    e.preventDefault();
    var value = $(this).attr('data-handle');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('wishlist')) || []; } catch(e) {}
    if ($.inArray(value, list) === -1) {
      list.push(value);
    }
    localStorage.setItem('wishlist', JSON.stringify(list));
    localStorage.setItem('user_wishlist_cnt', list.length);
    $("[data-handle='" + value + "']").addClass('active-wishlist').removeClass('wishlist-custom-action');
    $('.wishlist-counter').text(list.length);
  });

  // ── Remove from wishlist ────────────────────────────────────────────────────
  jQuery(document).on('click', '.active-wishlist', function(e) {
    e.preventDefault();
    var to_delete = $(this).attr('data-handle');
    var list = [];
    try { list = JSON.parse(localStorage.getItem('wishlist')) || []; } catch(e) {}
    var index = list.indexOf(to_delete);
    if (index > -1) {
      list.splice(index, 1);
      localStorage.setItem('wishlist', JSON.stringify(list));
      localStorage.setItem('user_wishlist_cnt', list.length);
      $("[data-handle='" + to_delete + "']").removeClass('active-wishlist').addClass('wishlist-custom-action');
      $('.wishlist-counter').text(list.length);
    }
    if (window.location.pathname.indexOf('wishlist') > -1) {
      location.reload();
    }
  });

  // ── Sync wishlist to logged-in customer via cart attributes ─────────────────
  if (window.wishlistCustomerId && wishlist_pro.length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { customer_wishlist: JSON.stringify(wishlist_pro) } })
    });
  }

  // ── On login: pull wishlist from cart attributes and merge into localStorage ─
  if (window.wishlistCustomerId) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var saved = cart.attributes && cart.attributes['customer_wishlist'];
        if (!saved) return;
        var serverList = [];
        try { serverList = JSON.parse(saved); } catch(e) {}
        var local = [];
        try { local = JSON.parse(localStorage.getItem('wishlist')) || []; } catch(e) {}
        serverList.forEach(function(h) {
          if (local.indexOf(h) === -1) local.push(h);
        });
        localStorage.setItem('wishlist', JSON.stringify(local));
        localStorage.setItem('user_wishlist_cnt', local.length);
        $('.wishlist-counter').text(local.length);
        $(".wishlist-custom-action").each(function() {
          var h = $(this).attr("data-handle");
          if ($.inArray(h, local) >= 0) {
            $(this).addClass('active-wishlist').removeClass('wishlist-custom-action');
          }
        });
      });
  }

});